import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import extraReducers from "../store/extraReducers";

const initialState = {
  startDate: "",
  endDate: "",
};

const calendarSlice = createSlice({
  name: "calendar",
  initialState,
  extraReducers: extraReducers(initialState),
  reducers: {
    setStartDate: (state, { payload }: PayloadAction<string>) => {
      state.startDate = payload;
    },
    setEndDate: (state, { payload }: PayloadAction<string>) => {
      state.endDate = payload;
    },
    resetStartDate: () => initialState,
  },
});

export const { setStartDate, setEndDate, resetStartDate } = calendarSlice.actions;

export default calendarSlice.reducer;
